import FeatureGate from "@/src/components/feature-gate";
import EventsCreationScreen from "@/src/screens/events/events-form/events-creation-screen";
import { useGetEventByIdQuery } from "@/src/services/api/events/events.hooks";
import { useLocalSearchParams } from "expo-router";
import { ActivityIndicator, View } from "react-native";

function EventEditContent() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const { data: eventToEdit, isLoading } = useGetEventByIdQuery(id);
  if (isLoading)
    return (
      <View className="flex-1 bg-white justify-between items-center">
        <ActivityIndicator size="large" />
      </View>
    );
  if (!eventToEdit) return null;
  return <EventsCreationScreen eventToEdit={eventToEdit} />;
}

export default function EventEdit() {
  return (
    <FeatureGate feature="events">
      <EventEditContent />
    </FeatureGate>
  );
}
